<template>

  <!-- Overlay Start -->
  <div class="overlay"></div>
  <!-- Overlay End -->

  <!-- Slider Start -->
  <div class="section slider-section">

    <!-- Slider Shape Start -->
    <!-- <div class="slider-shape">
      <img class="shape-1 animation-round" src="/assets/images/shape/shape-8.png" alt="Shape">
    </div> -->
    <!-- Slider Shape End -->

    <div class="container">

      <!-- Slider Content Start -->
      <div class="slider-content">
        <h4 class="sub-title">Master Your Maritime Knowledge!</h4>
        <h2 class="main-title">Prepare for the MCQ Exam with <span>tailored tests.</span></h2>
        <p>Choose from free trials or premium packages and set sail for success!</p>
        <router-link class="btn btn-primary btn-hover-dark" to="/packages">Check Packages</router-link>
      </div>
      <!-- Slider Content End -->

    </div>

    <!-- Slider Courses Box Start -->
    <div class="slider-courses-box">

      <img class="shape-1 animation-left" src="/assets/images/shape/shape-5.png" alt="Shape">

      <div class="box-content">
        <div class="box-wrapper">
          <i class="flaticon-open-book"></i>
          <span class="count">300+</span>
          <p>Questions</p>
        </div>
      </div>

      <img class="shape-2" src="/assets/images/shape/shape-6.png" alt="Shape">

    </div>
    <!-- Slider Courses Box End -->

    <!-- Slider Rating Box Start -->
    <div class="slider-rating-box">

      <div class="box-rating">
        <div class="box-wrapper">
          <span class="count">4.8 <i class="flaticon-star"></i></span>
          <p>Rating (81)</p>
        </div>
      </div>

      <img class="shape animation-up" src="/assets/images/shape/shape-7.png" alt="Shape">

    </div>
    <!-- Slider Rating Box End -->

    <!-- Slider Images Start -->
    <div class="slider-images">
      <div class="images">
        <img src="/assets/images/slider/slider-1.gif" alt="Slider">
      </div>
    </div>
    <!-- Slider Images End -->

    <!-- Slider Video Start -->
    <div class="slider-video">
      <img class="shape-1" src="/assets/images/shape/shape-9.png" alt="Shape">

      <div class="video-play">
        <img src="/assets/images/shape/shape-10.png" alt="Shape">
      </div>
    </div>
    <!-- Slider Video End -->

  </div>
  <!-- Slider End -->

  <!-- How It Work End -->
  <div class="section section-padding mt-n1">
    <div class="container">

      <!-- Section Title Start -->
      <div class="section-title shape-03 text-center">
        <h5 class="sub-title">Over 300+ Questions</h5>
        <h2 class="main-title">How It <span> Works?</span></h2>
      </div>
      <!-- Section Title End -->

      <!-- How it Work Wrapper Start -->
      <div class="how-it-work-wrapper">

        <!-- Single Work Start -->
        <div class="single-work">
          <img class="shape-1" src="/assets/images/shape/shape-15.png" alt="Shape">

          <div class="work-icon">
            <i class="flaticon-transparency"></i>
          </div>
          <div class="work-content">
            <h3 class="title">Find Your Course</h3>
            <p>Choose the right final test package and navigate your way to MCQ success.</p>
          </div>
        </div>
        <!-- Single Work End -->

        <!-- Single Work Start -->
        <div class="work-arrow">
          <img class="arrow" src="/assets/images/shape/shape-17.png" alt="Shape">
        </div>
        <!-- Single Work End -->

        <!-- Single Work Start -->
        <div class="single-work">
          <img class="shape-2" src="/assets/images/shape/shape-15.png" alt="Shape">

          <div class="work-icon">
            <i class="flaticon-forms"></i>
          </div>
          <div class="work-content">
            <h3 class="title">Attempt Final Tests</h3>
            <p>Sharpen your maritime knowledge with expert-designed final tests.</p>
          </div>
        </div>
        <!-- Single Work End -->

        <!-- Single Work Start -->
        <div class="work-arrow">
          <img class="arrow" src="/assets/images/shape/shape-17.png" alt="Shape">
        </div>
        <!-- Single Work End -->

        <!-- Single Work Start -->
        <div class="single-work">
          <img class="shape-3" src="/assets/images/shape/shape-16.png" alt="Shape">

          <div class="work-icon">
            <i class="flaticon-badge"></i>
          </div>
          <div class="work-content">
            <h3 class="title">Get Certified</h3>
            <p>Boost your maritime career by acing the MSQ exam with COLREGs.</p>
          </div>
        </div>
        <!-- Single Work End -->

      </div>

    </div>
  </div>
  <!-- How It Work End -->

  <!-- Packages Start -->
  <div class="section section-padding mt-n10">
    <div class="container">

      <!-- Section Title Start -->
      <div class="section-title shape-03 text-center">
        <h2 class="main-title">Select from below<span> Packages</span></h2>
      </div>
      <!-- Section Title End -->

      <div class="row gx-10">
        <div class="col-lg-3 padding-right-0">
          <!-- Courses Details Sidebar Start -->
          <div class="sidebar">
            <!-- Sidebar Widget Information Start -->
            <div class="sidebar-widget widget-information">
              <div class="info-price">
                <span class="price">Basic</span>
                <span class="package-price">$20</span>
              </div>
              <div class="info-list">
                <ul>
                  <li><i class="icofont-book-alt"></i> <strong>Questions</strong> <span>10</span></li>
                  <li><i class="icofont-book"></i> <strong>Practice Test</strong> <span>Yes</span></li>
                  <li><i class="icofont-clock-time"></i> <strong>Final Test Attempts</strong> <span>2</span></li>
                </ul>
              </div>
              <div class="info-btn">
                <router-link class="btn btn-primary btn-hover-dark" to="/packages">Purchase Now</router-link>
              </div>
            </div>
            <!-- Sidebar Widget Information End -->
          </div>
          <!-- Courses Details Sidebar End -->
        </div>


        <div class="col-lg-3 padding-right-0">
          <!-- Courses Details Sidebar Start -->
          <div class="sidebar">
            <!-- Sidebar Widget Information Start -->
            <div class="sidebar-widget widget-information">
              <div class="info-price">
                <span class="price">Intermediate</span>
                <span class="package-price">$50</span>
              </div>
              <div class="info-list">
                <ul>
                  <li><i class="icofont-book-alt"></i> <strong>Questions</strong> <span>15</span></li>
                  <li><i class="icofont-book"></i> <strong>Practice Test</strong> <span>Yes</span></li>
                  <li><i class="icofont-clock-time"></i> <strong>Final Test Attempts</strong> <span>5</span></li>
                </ul>
              </div>
              <div class="info-btn">
                <router-link class="btn btn-primary btn-hover-dark" to="/packages">Purchase Now</router-link>
              </div>
            </div>
            <!-- Sidebar Widget Information End -->
          </div>
          <!-- Courses Details Sidebar End -->
        </div>


        <div class="col-lg-3 padding-right-0">
          <!-- Courses Details Sidebar Start -->
          <div class="sidebar">
            <!-- Sidebar Widget Information Start -->
            <div class="sidebar-widget widget-information">
              <div class="info-price">
                <span class="price">Advance</span>
                <span class="package-price">$100</span>
              </div>
              <div class="info-list">
                <ul>
                  <li><i class="icofont-book-alt"></i> <strong>Questions</strong> <span>20</span></li>
                  <li><i class="icofont-book"></i> <strong>Practice Test</strong> <span>Yes</span></li>
                  <li><i class="icofont-clock-time"></i> <strong>Final Test Attempts</strong> <span>10</span></li>
                </ul>
              </div>
              <div class="info-btn">
                <router-link class="btn btn-primary btn-hover-dark" to="/packages">Purchase Now</router-link>
              </div>
            </div>
            <!-- Sidebar Widget Information End -->
          </div>
          <!-- Courses Details Sidebar End -->
        </div>

        
        <div class="col-lg-3 padding-right-0">
          <!-- Courses Details Sidebar Start -->
          <div class="sidebar">
            <!-- Sidebar Widget Information Start -->
            <div class="sidebar-widget widget-information border-color-blue">
              <div class="info-price">
                <span class="price color-blue">Organisation / <br/>Customized</span>
              </div>
              <div class="info-list">
                <ul>
                  <li><i class="icofont-book-alt color-blue"></i> <strong>Questions</strong> <span>On Demand</span></li>
                  <li><i class="icofont-book color-blue" ></i> <strong>Practice Test</strong> <span>Yes</span></li>
                  <li><i class="icofont-clock-time color-blue"></i> <strong style="font-size: 13px;">Final Test Attempts</strong> <span style="font-size: 15px;">On Demand</span></li>
                </ul>
              </div>
              <div class="info-btn">
                <router-link to="/retention-package" class="btn btn-primary btn-hover-dark background-color-blue">Purchase Now</router-link>
              </div>
            </div>
            <!-- Sidebar Widget Information End -->
          </div>
          <!-- Courses Details Sidebar End -->
        </div>
      </div>
    </div>
  </div>
  <!-- Packages End -->

  <!-- Call to Action Start -->
  <div class="section padding-bottom-50">
    <div class="container">

      <!-- Call to Action Wrapper Start -->
      <div class="call-to-action-wrapper">

        <img class="cat-shape-01 animation-round" src="/assets/images/shape/shape-12.png" alt="Shape">
        <img class="cat-shape-02" src="/assets/images/shape/shape-13.svg" alt="Shape">
        <img class="cat-shape-03 animation-round" src="/assets/images/shape/shape-12.png" alt="Shape">

        <div class="row align-items-center">
          <div class="col-md-6">

            <!-- Section Title Start -->
            <div class="section-title shape-02">
              <h5 class="sub-title">Try for Free!</h5>
              <h2 class="main-title">Sign up for a free trial &amp; start your <span>MCQ prep!</span></h2>
            </div>
            <!-- Section Title End -->

          </div>
          <div class="col-md-6">
            <div class="call-to-action-btn">
              <router-link class="btn btn-primary btn-hover-dark" to="/contact">Purchase Now</router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- Call to Action Wrapper End -->

    </div>
  </div>
  <!-- Call to Action End -->
   

  <!-- Contact Start -->
  <div class="section section-padding padding-top-0">
    <div class="container">

      <!-- Contact Wrapper Start -->
      <div class="contact-wrapper">
        <div class="row align-items-center">
          <div class="col-lg-6">

            <!-- Contact Info Start -->
            <div class="contact-info">

              <img class="shape animation-round" src="/assets/images/shape/shape-12.png" alt="Shape">

              <!-- Single Contact Info End -->
              <!-- Single Contact Info Start -->
              <div class="single-contact-info">
                <div class="info-icon">
                  <i class="flaticon-email"></i>
                </div>
                <div class="info-content">
                  <h6 class="title">Email Address.</h6>
                  <p class="font-size-14"><a href="mailto:admin@thecolregs.com">admin@thecolregs.com</a></p>
                </div>
              </div>
              <!-- Single Contact Info End -->
              <!-- Single Contact Info Start -->
              <div class="single-contact-info">
                <div class="info-icon">
                  <i class="flaticon-pin"></i>
                </div>
                <div class="info-content">
                  <h6 class="title">Office Address.</h6>
                  <p>47 Knoll Drive, London, England, N14 5LU</p>
                </div>
              </div>
              <!-- Single Contact Info End -->
            </div>
            <!-- Contact Info End -->

          </div>
          <div class="col-lg-6">

            <!-- Contact Form Start -->
            <div class="contact-form">
              <h3 class="title">Get in Touch <span>With Us</span></h3>

              <div class="form-wrapper">
                <form id="contact-form" @submit.prevent='send_msg'>
                  <!-- Single Form Start -->
                  <div class="single-form">
                    <input type="text" v-model="form.name" placeholder="Name">
                  </div>
                  <!-- Single Form End -->
                  <!-- Single Form Start -->
                  <div class="single-form">
                    <input type="email" v-model="form.email" placeholder="Email">
                  </div>
                  <!-- Single Form End -->
                  <!-- Single Form Start -->
                  <div class="single-form">
                    <input type="text" v-model="form.subject" placeholder="Subject">
                  </div>
                  <!-- Single Form End -->
                  <!-- Single Form Start -->
                  <div class="single-form">
                    <textarea v-model="form.message" placeholder="Message"></textarea>
                  </div>
                  <!-- Single Form End -->
                  <p class="form-message"></p>
                  <!-- Single Form Start -->
                  <div class="single-form">
                    <button class="btn btn-primary btn-hover-dark w-100">
                      Send Message 
                      <div v-if='loader' class="loader"></div>
                      <i v-else class="flaticon-right"></i></button>
                  </div>
                  <div class="single-form" v-if='message'>
                    {{message}}
                  </div>
                  <!-- Single Form End -->
                </form>
              </div>
            </div>
            <!-- Contact Form End -->

          </div>
        </div>
      </div>
      <!-- Contact Wrapper End -->

    </div>
  </div>
  <!-- Contact End -->

  <!-- Download App Start -->
  <div class="section section-padding download-section">

    <div class="app-shape-1"></div>
    <div class="app-shape-2"></div>
    <div class="app-shape-3"></div>
    <div class="app-shape-4"></div>

    <div class="container">

      <!-- Download App Wrapper Start -->
      <div class="download-app-wrapper mt-n6">

        <!-- Section Title Start -->
        <div class="section-title section-title-white">
          <h5 class="sub-title">Want to practice from phone?</h5>
          <h2 class="main-title">Download our mobile app. to start your preparation.</h2>
        </div>
        <!-- Section Title End -->

        <img class="shape-1 animation-right" src="/assets/images/shape/shape-14.png" alt="Shape">

        <!-- Download App Button End -->
        <div class="download-app-btn">
          <ul class="app-btn opacity-0-4">
            <li>
              <a href="#">
                <img src="/assets/images/google-play.png" alt="Google Play">
              </a>
            </li>
            <li>
              <a href="#">
                <img src="/assets/images/app-store.png" alt="App Store">
              </a>
            </li>
          </ul>
          <div class="section-title section-title-white">
            <h5 class="sub-title">The mobile application is comming soon!</h5>
          </div>
        </div>
        <!-- Download App Button End -->

      </div>
      <!-- Download App Wrapper End -->

    </div>
  </div>
  <!-- Download App End -->

  <!-- Testimonial End -->
  <div class="section section-padding-02 mt-n1">
    <div class="container">

      <!-- Section Title Start -->
      <div class="section-title shape-03 text-center">
        <h5 class="sub-title">User Testimonial</h5>
        <h2 class="main-title">Feedback From <span> Users</span></h2>
      </div>
      <!-- Section Title End -->

      <!-- Testimonial Wrapper End -->
      <div class="testimonial-wrapper testimonial-active">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <!-- Single Testimonial Start -->
            <div class="single-testimonial swiper-slide">
              <div class="testimonial-author">
              <div class="testimonial-content">
                <h4 class="name">Sara Alexander</h4>
                <span class="designation">Certified Mariner, UK</span>
              </div>

                <span class="rating-star">
                  <span class="rating-bar" style="width: 80%;"></span>
                </span>
              </div>
              <div class="testimonial-content">
                <p>The practice tests were spot on! I highly recommend COLREGs for anyone serious about their maritime
                  certification. The practice tests were spot on! I highly recommend COLREGs for anyone serious about their maritime
                  certification.</p>
              </div>
            </div>
            <!-- Single Testimonial End -->

            <!-- Single Testimonial Start -->
            <div class="single-testimonial swiper-slide">
              <div class="testimonial-author">
              <div class="testimonial-content">
                <h4 class="name">Melissa Roberts</h4>
                <span class="designation">Deck Officer, UK</span>
              </div>

                <span class="rating-star">
                  <span class="rating-bar" style="width: 80%;"></span>
                </span>
              </div>
              <div class="testimonial-content">
                <p>COLREGs made my MSQ exam prep seamless! The final tests were realistic and helped me pass with
                  confidence. COLREGs made my MSQ exam prep seamless! The final tests were realistic and helped me pass with
                  confidence.</p>
              </div>
            </div>
            <!-- Single Testimonial End -->

            <!-- Single Testimonial Start -->
            <div class="single-testimonial swiper-slide">
              <div class="testimonial-author">
              <div class="testimonial-content">
                <h4 class="name">Sara Alexander</h4>
                <span class="designation">Product Designer, USA</span>
              </div>

                <span class="rating-star">
                  <span class="rating-bar" style="width: 80%;"></span>
                </span>
              </div>
              <div class="testimonial-content">
                <p>Lorem Ipsum has been the industry's standard dummy text since the 1500s, when an unknown printer took
                  a galley of type and scrambled it to make type specimen book has survived not five centuries but also
                  the leap into electronic.</p>
              </div>
            </div>
            <!-- Single Testimonial End -->
          </div>

          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <!-- Testimonial Wrapper End -->

    </div>
  </div>
  <!-- Testimonial End -->

</template>

<script>
import api from '@/services/api';
export default {
  name: 'Home',
  data(){
    return{
      // support_email: null,
      loader: false,
      form: {},
      message: null
    }
  },
  mounted() {
    document.title = "COLREGs - Master Your Maritime Exam with Confidence";
  },
  methods:{
    async send_msg(){
      this.loader = true;
      try{
        let res = await api.post(`/user/contact`, this.form , {
             requiresAuth: false
        });
        
        this.message = res.data.message;
        this.form = {};
        
      }catch (error) {
        console.log(error);
        this.message = error.response.data.error;
      }finally{
        this.loader = false;
      }
    }
  },
};
</script>
<style scoped>
button .loader {
  display: inline-block;
  margin-left: 8px; /* optional spacing between span and loader */
  vertical-align: middle;
}

.loader {
  width: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 4px solid white;
  border-right-color: #309255;
  animation: l2 1s infinite linear;
}
@keyframes l2 {to{transform: rotate(1turn)}}
</style>